import { forEach, get, isArray, isEmpty } from 'lodash';
import { findOptions } from './Filters/helpers';
import { InventorySearchEvents } from './events';
import Slider from './Filters/Slider';
import Dropdown from './Filters/Dropdown';
import Inputs from './Filters/Inputs';
import Checkboxes from './Filters/Checkboxes';

/**
 * Handles Filter creation
 * @param {HTMLElement} container   filter container
 * @param {Function} updateCallback callback function called when filter parameters change
 * @param {Object} searchParameters object of search parameters, ex. {make: 'Ford', year_min: '2010'}
 * @param {Object} data             inventory
 * @param {Object} selected         object of filters set up in WP Custom Filters
 */
class DSPFilter {
  constructor(container, updateCallback, searchParameters, data, selected) {
    this.container = container;
    this.type = container.getAttribute('data-type');
    this.searchParameter = container.id;
    this.updateCallback = updateCallback;
    this.data = data;
    this.options = findOptions(this.container, this.searchParameter, this.data);
    this.searchParameters = searchParameters;
    this.selected = selected;
  }

  create() {
    // if custom filters are set in WP, take filter params from
    // these filters and add them to search parameters object
    if (this.selected) {
      forEach(this.selected, (value, param) => {
        if (!param.includes(this.searchParameter)) {
          return;
        }

        if (isArray(value)) {
          this.searchParameters[this.searchParameter] = value.join(',') + ',';
        } else {
          this.searchParameters[param] = value;
        }
      });
    }

    this.container.dispatchEvent(
      new CustomEvent(InventorySearchEvents.PRE_SEARCH_FILTER_UPDATE, {
        bubbles: true,
        detail: { filter: this },
      })
    );

    let filter;
    switch (this.type) {
      case 'slider':
        let sliderOptions = {
          start: [this.options.minValue, this.options.maxValue],
          step: this.options.step,
          behaviour: 'drag',
          connect: true,
          range: {
            min: [this.options.minValue],
            max: [this.options.maxValue],
          },
        };

        filter = new Slider(
          this.searchParameter,
          sliderOptions,
          this.updateCallback,
          this.searchParameters
        );
        break;

      case 'checkboxes':
        filter = new Checkboxes(
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters
        );
        break;

      case 'inputs':
        filter = new Inputs(
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters
        );
        break;

      case 'dropdown':
        filter = new Dropdown(
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters
        );
        break;
    }

    filter.create();
    filter.update();

    this.container.dispatchEvent(
      new CustomEvent(InventorySearchEvents.POST_SEARCH_FILTER_UPDATE, {
        bubbles: true,
        detail: { filter: this },
      })
    );
  }
}

export default DSPFilter;
